import { AnchorButton } from "components/Button/AnchorButton";
import { IconCircleWavyCheck } from "components/Icons/IconCircleWavyCheck";
import { Badge } from "components/Badge/Badge";
import styles from "./CustomPlanBanner.module.css";
import pageStyles from "./PricingPage.module.css";
import { IconProjectStatusDraft } from "../../components/Icons/IconProjectStatusDraft";

export function CustomPlanBanner() {
  return (
    <div className={pageStyles.sectionCentered}>
      <div className={styles.content}>
        <div>
          <h1>
            Contact us to get a data platform tailored to your organization.
          </h1>
          <AnchorButton
            size="M"
            theme="primary-light"
            href="mailto:sales@dune.com"
          >
            Contact us
          </AnchorButton>
        </div>

        <div className={styles.featureList}>
          <ul>
            <li>
              <IconCircleWavyCheck /> Custom quotas
            </li>
            <li>
              <IconCircleWavyCheck /> Customizable embeds
            </li>
            <li>
              <IconCircleWavyCheck /> Custom API endpoints
            </li>
          </ul>
          <ul>
            <li>
              <IconCircleWavyCheck /> <span>Telegram support</span>
            </li>
            <li>
              <IconProjectStatusDraft />
              <span>
                Private data uploads
                <Soon />
              </span>
            </li>
            <li>
              <IconProjectStatusDraft />
              <span>
                Private materialized views
                <Soon />
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

const Soon = () => (
  <span className={styles.soonBadge}>
    <Badge size="M" variant="filled" color="brand-blue">
      Soon
    </Badge>
  </span>
);
